function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "illus/entity/definition"
}, React.createElement("path", {
  id: "path",
  d: "M16 15.01C15.451 15.01 15.01 15.451 15.01 16C15.01 16.549 15.451 16.99 16 16.99C16.549 16.99 16.99 16.549 16.99 16C16.99 15.451 16.549 15.01 16 15.01ZM16 7C11.032 7 7 11.032 7 16C7 20.968 11.032 25 16 25C20.968 25 25 20.968 25 16C25 11.032 20.968 7 16 7ZM17.971 17.971L10.6 21.4L14.029 14.029L21.4 10.6L17.971 17.971Z",
  fill: "#303030"
}));

var SvgDefinition = function SvgDefinition(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,";
export { SvgDefinition as ReactComponent };